import { HeadlineSize9Medium } from "../ui/typographic";

export const LayoutCardHeader = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <HeadlineSize9Medium className={className}>{children}</HeadlineSize9Medium>
  );
};
